<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div id="compeSearchCase">
        <div class="flex">
          <h4 class="title">
            爱采购行业案例查询
            <el-tooltip
              class="item"
              effect="dark"
              content="仅展示近30天数据"
              placement="top-start"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </h4>
          <div class="select">
            <el-select
              v-model="tradeValue"
              placeholder="一级行业分类"
              size="small"
              @change="selectSubTrade"
            >
              <el-option
                v-for="item in tradeList"
                :key="item.index"
                :label="item.f_industry"
                :value="{ value: item.f_industry, label: item.index }"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="subTradeValue"
              placeholder="二级行业分类"
              size="small"
              @change="clickSubTrade"
            >
              <el-option
                v-for="item in subTradeList"
                :key="item.index"
                :label="item.s_industry"
                :value="{ value: item.s_industry, label: item.s_industry }"
              >
              </el-option>
            </el-select>
            <!-- <el-cascader v-model="value" placeholder="一级行业分类/二级行业分类" :options="options" size="small"
                            @change="handleChange"></el-cascader> -->
          </div>
        </div>
        <div class="title2">优秀行业案例</div>
        <div class="boxContainer">
          <el-row :gutter="10">
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.exposure_case
                    ? industryCase.exposure_case
                    : "暂无数据"
                }}</span>
                <span>曝光</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.click_case ? industryCase.click_case : "暂无数据"
                }}</span>
                <span>点击</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.visitor_case
                    ? industryCase.visitor_case
                    : "暂无数据"
                }}</span>
                <span>访客</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.phone_case ? industryCase.phone_case : "暂无数据"
                }}</span>
                <span>电话</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.form_case ? industryCase.form_case : "暂无数据"
                }}</span>
                <span>表单</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.im_case ? industryCase.im_case : "暂无数据"
                }}</span>
                <span>IM</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="title2">行业均值</div>
        <div class="boxContainer">
          <el-row :gutter="10">
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.exposure_mean
                    ? industryCase.exposure_mean
                    : "暂无数据"
                }}</span>
                <span>曝光</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.click_mean ? industryCase.click_mean : "暂无数据"
                }}</span>
                <span>点击</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.visitor_mean
                    ? industryCase.visitor_mean
                    : "暂无数据"
                }}</span>
                <span>访客</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.phone_mean ? industryCase.phone_mean : "暂无数据"
                }}</span>
                <span>电话</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.form_mean ? industryCase.form_mean : "暂无数据"
                }}</span>
                <span>表单</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{
                  industryCase.im_mean ? industryCase.im_mean : "暂无数据"
                }}</span>
                <span>IM</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script  >
import {
  getAcgCustData,
  getAcgIndustry,
  getAcgIndustryCase,
} from "../utils/request.js";
import { Loading } from "element-ui";
export default {
  name: "IndustryCaseQuery",
  props: {},
  data() {
    return {
      value: [],
      tradeList: [], //一级行业
      tradeValue: "",
      subTradeValue: "",
      subTradeList: [], //二级行业
      industryCase: [], //行业案例查询
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.selectTrade(); //渲染行业数据
    });
  },
  methods: {
    companySearch() {
      if (this.companyName == "") {
        this.$alert('请输入公司全称', {
          confirmButtonText: '确定',
        });
      } else {
        this.DaoQiChaXun();
      }
    },

    handleChange(value) {
      console.log(value[1]);
    },
    // 爱采购客服及到期时间查询
    DaoQiChaXun() {
      let params = {
        company_name: this.companyName,
      };
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      getAcgCustData(params).then((res) => {
        if (res.status == 200) {
          this.companyData = res.data.data;
          loadingInstance.close();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取行业数据
    selectTrade() {
      let params = {};
      getAcgIndustry(params).then((res) => {
        if (res.status == 200) {
          this.tradeList = res.data.data;
          // console.log(res, '获取行业数据')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //二级行业筛选
    selectSubTrade(e) {
      this.industryCase = "";
      this.subTradeValue = "";
      let params = {
        f_industry: e.value,
      };
      getAcgIndustry(params).then((res) => {
        if (res.status == 200) {
          // console.log(res.data.data, '--------------二级行业筛选')
          this.subTradeList = res.data.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clickSubTrade(e) {
      //点击行业
      // this.firstTradeId = e.label
      console.log(e, "点击行业");
      this.HangYeAnLi();
    },
    // 爱采购行业案例查询
    HangYeAnLi() {
      let params = {
        f_industry: this.tradeValue.value,
        s_industry: this.subTradeValue.value,
      };
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      getAcgIndustryCase(params).then((res) => {
        if (res.status == 200) {
          this.industryCase = res.data.data[0];
          console.log(res.data.data[0], "爱采购行业案例查询");
          loadingInstance.close();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../assets/reset.less";
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  position: relative;
  padding-left: 15px;

  &::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 5px;
    background-color: @Color8;
    top: 50%;
    margin-top: -10px;
    left: 0px;
  }
}

.sear-div-line {
  display: flex;
  align-items: center;
  color: @Color10;
  font-size: 14px;

  .sear-total {
    color: @Color8;
    font-size: 24px;
    margin-left: 5px;

    i {
      font-size: 14px;
    }
  }
}

.industry-select-wrap {
  display: flex;
  align-items: center;
  color: @Color10;
  font-size: 14px;

  .com-div-wrap {
    .el-select {
      margin-left: 5px;
    }
  }
}

.boxContainer {
  margin-top: 7px;
  margin-bottom: 7px;

  .el-col-4 {
    .grid-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 1.2em;
      padding: 5px;
      color: #fff;
      font-size: 14px;
    }

    &:nth-child(1) .grid-content {
      background-color: @Color3;
    }

    &:nth-child(2) .grid-content {
      background-color: @Color2;
    }

    &:nth-child(3) .grid-content {
      background-color: @Color4;
    }

    &:nth-child(4) .grid-content {
      background-color: @Color5;
    }

    &:nth-child(5) .grid-content {
      background-color: @Color13;
    }

    &:nth-child(6) .grid-content {
      background-color: @Color14;
    }
  }

  .el-col-12 {
    margin-top: 10px;

    .grid-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 1.6em;
      padding: 10px;
      color: @Color8;
      font-size: 16px;
      background-color: @Color11;
    }
  }
}

h4.title {
  &::before {
    background-color: @Color6;
  }

  i {
    color: @Color8;
    font-size: 14px;
  }
}

.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-pagination {
  text-align: right;
  margin: 10px 0px;
}

.download {
  font-size: 14px;
  color: @Color7;
}

.tabs {
  display: flex;
  align-items: center;

  .tab {
    border: 1px solid #eee;
    background-color: #f9f9f9;
    margin-right: 15px;
    width: 76px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #333;
    font-size: 14px;
    cursor: pointer;
  }

  .active {
    background-color: #fdb050;
    border: 1px solid #fdb050;
    color: #fff;
  }
}

.rank-h-title {
  display: block;
  font-size: 16px;
  color: @Color6;
  margin-bottom: 10px;
}

.calcLine {
  position: relative;
  top: -1px;
  margin-left: 2px;
  display: inline-block;
  height: 5px;
  background-color: #00d7db;
  vertical-align: middle;
}

/deep/.input-with-select {
  width: 40%;
}

.select {
  /deep/.el-input {
    width: 150px;
    margin-left: 10px;
  }
}

.border {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px;
  min-height: 145px;
}

.title2 {
  background-color: rgba(242, 242, 242, 1);
  text-align: center;
  padding: 4px;
}
</style>